import { render, staticRenderFns } from "./PatientInquiryList.vue?vue&type=template&id=9e47e3e8&scoped=true&"
import script from "./PatientInquiryList.vue?vue&type=script&lang=js&"
export * from "./PatientInquiryList.vue?vue&type=script&lang=js&"
import style0 from "./PatientInquiryList.vue?vue&type=style&index=0&id=9e47e3e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e47e3e8",
  null
  
)

export default component.exports